import {
	AutoPlayAtom,
	EditMode,
	IsInAuthor,
	IsPreviewGenerator,
	TapEvent,
} from "../state/ui";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";

import { NumberOfPages } from "../state/selectors";
import { PageIndex } from "../state/page";
import { useEffect } from "react";

export function TriggerAutoPlay() {
	const autoPlayAtom = useRecoilValue(AutoPlayAtom);
	const numberOfPages = useRecoilValue(NumberOfPages);
	const setTapEvent = useSetRecoilState(TapEvent);
	const isInEmbedded = useRecoilValue(IsInAuthor);
	const isPreviewer = useRecoilValue(IsPreviewGenerator);
	const editMode = useRecoilValue(EditMode);
	const [pageIndex, setPageIndex] = useRecoilState(PageIndex);

	useEffect(() => {
		if (autoPlayAtom.autoPlay === -1) return; // it thasnt been set yet
		if (isPreviewer) return;
		if (isInEmbedded && editMode) return;
		if (!autoPlayAtom.autoPlay) return;

		const interval = setInterval(() => {
			if (pageIndex === numberOfPages && autoPlayAtom.loop === "forever") {
				setPageIndex(1);
			} else {
				setTapEvent("forward");
			}
		}, autoPlayAtom.autoPlay * 1000);

		return () => {
			clearInterval(interval);
		};
	}, [
		autoPlayAtom,
		setPageIndex,
		numberOfPages,
		setTapEvent,
		editMode,
		isInEmbedded,
		isPreviewer,
		pageIndex,
	]);
	return <></>;
}
